import React from 'react';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { SeoMeta } from '@/components/seo/SeoMeta';
import { useCMSContent } from '@/hooks/useCMSContent';
import { renderMarkdown, PageLoading } from './shared';

export const PrivacyPage = () => {
  const { pathname } = useLocation();
  const isCookies = pathname === '/cookies';
  const { content, loading } = useCMSContent();

  if (loading) return <PageLoading />;

  const privacyContent = content?.footer?.privacy_page || 'Innehållet har inte konfigurerats ännu. Gå till Admin > Footer för att redigera.';

  const seoTitle = isCookies ? 'Cookies och spårning' : 'Integritetspolicy';
  const seoDescription = isCookies
    ? 'Läs hur ByggFynd använder cookies och liknande teknik för att förbättra din upplevelse och följa lagkrav.'
    : 'Läs ByggFynds integritetspolicy. Vi förklarar hur personuppgifter behandlas enligt GDPR vid konto, beställning, betalning och support.';
  const canonicalPath = isCookies ? '/cookies' : '/integritetspolicy';

  return (
    <div className="bg-[#F8FAFC] min-h-screen" data-testid="privacy-page">
      <SeoMeta title={seoTitle} description={seoDescription} canonicalPath={canonicalPath}>
        <meta
          name="keywords"
          content={
            isCookies
              ? 'cookies, spårning, ByggFynd, samtycke, webbläsare'
              : 'integritetspolicy, GDPR, personuppgifter, ByggFynd, dataskydd, e-handel byggvaror'
          }
        />
      </SeoMeta>
      <div className="container-main py-8">
        <Breadcrumbs items={[{ label: isCookies ? 'Cookies' : 'Integritetspolicy' }]} />

        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-black text-[#0F172A] mb-8">
            {isCookies ? 'Cookies' : 'Integritetspolicy'}
          </h1>

          <div className="bg-white rounded-md shadow-sm p-8">
            <div className="prose max-w-none">
              {renderMarkdown(privacyContent)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
